<template>
  <section class="copyright">
    <div class="container">
      <div class="footer__copyright">
        <p class="footer__copyright-item">
          Copyright © {{ currentYear }} Videomedi. Todos os Direitos Reservados.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Copyright",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
